<vsc-icon
    #tooltip="matTooltip"
    [matTooltip]="'Copied!' | transloco"
    matTooltipPosition="above"
    matTooltipClass="v-hidden"
    [matTooltipHideDelay]="tooltipDuration"
    (click)="copyToClipboard(tooltip)"
    (keydown.enter)="copyToClipboard(tooltip)"
    (keydown.space)="$event.preventDefault(); copyToClipboard(tooltip)"
    tabindex="0"
    >copy</vsc-icon
>
